<template>
    <div class="home_kh_box">
        <HeaderNav
            header-title="砼享云司机端"
            left-icon-name="1"
            right-icon-name="1"
        ></HeaderNav>
        <div class="header-box">
            <img src="@/assets/images/home_sj/bannner.jpg" alt="">
        </div>
        <div class="home-content">
            <template v-for="(item, index) in homeData">
                <div
                    class="item"
                    :class="`color${(index)%4}`"
                    :key="index"
                    @click="routerLink(item.routerName)"
                    v-if="item.routerName"
                >
                    <div class="info">
                        <div class="split-icon">
                            <i></i>
                        </div>
                        <div class="tit">
                            <h4>{{ item.name }}</h4>
                            <p>
                                {{ item.info }}
                            </p>
                        </div>
                    </div>
                    <div class="img-con">
                        <img :src="item.imgUrl" width="100%">
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import imgUrl1 from './../../assets/images/home_sj/attendance_record.png';
import imgUrl2 from './../../assets/images/home_sj/tanker.png';
import imgUrl3 from './../../assets/images/home_sj/order.png';
import imgUrl4 from './../../assets/images/home_sj/map.png';
import imgUrl5 from './../../assets/images/home_sj/evaluate.png';
import imgUrl6 from './../../assets/images/home_sj/seaarch.png';
import imgUrl7 from './../../assets/images/home_sj/gztz.png';
export default {
    data() {
        return {
            homeData: [
                {
                    name: '出车管理',
                    info: '此处为出车管理简单介绍',
                    imgUrl: imgUrl1,
                    routerName: 'carManage',
                },
                {
                    name: '车辆排队',
                    info: '此处为车辆排队简单介绍',
                    imgUrl: imgUrl2,
                    routerName: 'vehicleQueue',
                },
                {
                    name: '司机接单',
                    info: '此处为司机接单简单介绍',
                    imgUrl: imgUrl3,
                    routerName: 'workOrder',
                },
                {
                    name: '智能导航',
                    info: '此处为智能导航简单介绍',
                    imgUrl: imgUrl4,
                },
                {
                    name: '交付评价',
                    info: '此处为交付评价简单介绍',
                    imgUrl: imgUrl5,
                    routerName: 'transSheet',
                },
                {
                    name: '趟费查询',
                    info: '此处为趟费查询简单介绍',
                    imgUrl: imgUrl6,
                    routerName: 'trainsCostQuery',
                },
                {
                    name: '故障台账',
                    info: '此处为故障台账简单介绍',
                    imgUrl: imgUrl7,
                    routerName: 'faultList',
                },
            ],
        };
    },
    components: {
        HeaderNav,
    },
    mounted() {

    },
    methods: {
        routerLink(routerName) {
            if (routerName) {
                this.$router.isBack = 2;
                this.$router.push({ name: routerName });
            }
        },
    },
};

</script>
<style lang='stylus'>
.home_kh_box
    height 100%
    padding-top 44rpx
    .header-box
        width 100%
        height 184rpx
        img
            width 100%
            height 100%
    .home-content
        background #F0F0F0
        overflow hidden
        height calc(100% - 184rpx)
        .item
            width calc(50% - 15rpx);
            height 87rpx;
            background rgba(255,255,255,1)
            box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.1)
            float left
            margin 10rpx
            padding 10rpx 0 10rpx 10rpx
            &:nth-child(1n)
                margin-right 0
            .info
                float left
                width calc(100% - 55rpx)
                height 100%
                .split-icon
                    width 3rpx
                    height 100%
                    float left
                    i
                        width 3rpx
                        height 13rpx
                        background #3595FA
                        display inline-block
                        margin-top 9rpx
                .tit
                    width calc(100% - 3rpx)
                    height 100%
                    float left
                    padding-left 10rpx
                    h4
                        font-size 14rpx
                        margin 5rpx 0
                    p
                        font-size 10rpx
                        color #979EA7
            .img-con
                float left
                width 55rpx
                height 55rpx
                img
                    width 100%
                    height 100%
            &.color0
                .split-icon
                    i
                        background #3595FA
            &.color1
                .split-icon
                    i
                        background #F15545
            &.color2
                .split-icon
                    i
                        background #FF6600
            &.color3
                .split-icon
                    i
                        background #16BC84
</style>
